// Bottom navigation per mobile (5 tab)
import { NavLink } from 'react-router-dom';
import { FileText, Target, TrendingUp, Bell, Settings as SettingsIcon } from 'lucide-react';
import { cn } from '@/utils';
import { useRemindersStore } from '@/store/remindersStore';
import { useI18n } from '@/i18n';

export function BottomNav() {
  const activeReminders = useRemindersStore((s) => s.reminders.filter((r) => r.enabled).length);
  const { t } = useI18n();

  const tabs = [
    { to: '/notes', label: t('nav.notes'), icon: FileText, color: 'text-amber-500' },
    { to: '/personal', label: t('nav.personal'), icon: Target, color: 'text-blue-500' },
    { to: '/profit', label: t('nav.profit'), icon: TrendingUp, color: 'text-emerald-500' },
    { to: '/reminders', label: t('nav.reminders'), icon: Bell, color: 'text-rose-500' },
    { to: '/settings', label: t('nav.settings'), icon: SettingsIcon, color: 'text-slate-500' },
  ];

  return (
    <nav
      className="shrink-0 bg-white/95 dark:bg-slate-900/95 backdrop-blur-lg border-t border-slate-200 dark:border-slate-800"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="mx-auto max-w-2xl grid grid-cols-5">
        {tabs.map(({ to, label, icon: Icon, color }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center gap-0.5 py-2.5 transition-colors relative',
                isActive ? color : 'text-slate-400 dark:text-slate-500',
              )
            }
          >
            {({ isActive }) => (
              <>
                <div className="relative">
                  <Icon size={22} strokeWidth={isActive ? 2.5 : 2} />
                  {to === '/reminders' && activeReminders > 0 && (
                    <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-rose-500 text-white text-[9px] font-bold flex items-center justify-center">
                      {activeReminders}
                    </span>
                  )}
                </div>
                <span className={cn('text-[10px] font-medium', isActive && 'font-semibold')}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
